module.exports = __webpack_public_path__ + "img/Cards_Hand.eb2f0e03.svg";